import {
  IMarginLevelBalance,
  useMarginLevelWindow,
} from "@/hooks/useMarginLevelsWindow";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { BalanceIndicator } from "@/components/shared/balanceIndicator";
import { createColumnHelper, SortingState } from "@tanstack/react-table";
import { IColumn } from "@/domain/interfaces/sfTable.interface";
import { Loader } from "lucide-react";
import { PaneBody } from "../pane/paneBody";
import { PaneSubHeader } from "../pane/paneSubHeader";
import { cn } from "@/lib/utils";
import { formatNumber } from "@/lib/utils";
import { useState } from "react";
import { useGrid } from "@/hooks/useGrid";
import { usePaneContext } from "../pane/paneContext";

const columnHelper = createColumnHelper<IMarginLevelBalance>();
const columns = [
  columnHelper.accessor("symbol", {
    header: "Symbol",
    enableSorting: false,
    maxSize: 100,
    minSize: 30,
  }),
  columnHelper.accessor("buyLevelsCount", {
    header: () => (
      <div style={{ textAlign: "center", width: "100%" }}>Balance</div>
    ),
    cell: (info) => (
      <BalanceIndicator
        buyLevels={info.row.original.buyLevelsCount}
        sellLevels={info.row.original.sellLevelsCount}
        buyVolume={info.row.original.buyVolumeSum}
        sellVolume={info.row.original.sellVolumeSum}
      />
    ),
    sortingFn: (a, b) => {
      const aTotal = a.original.buyLevelsCount + a.original.sellLevelsCount;
      const bTotal = b.original.buyLevelsCount + b.original.sellLevelsCount;
      return bTotal - aTotal;
    },
  }),
  columnHelper.accessor("prc", {
    // header: () => <div style={{ textAlign: "right", width: "100%" }}>Prc</div>,
    header: "Dist",
    cell: (info) => (
      <div style={{ textAlign: "right" }}>{formatNumber(info.getValue())}</div>
    ),
    size: 50,
    minSize: 10,
    sortingFn: "alphanumeric",
  }),
];

export function MarginLevelBalancePaneBody() {
  const marginLevels = useMarginLevelWindow();
  const isLoading = marginLevels.isLoading;
  const nodeId = usePaneContext();
  const { getNodeConfig } = useGrid(nodeId);
  const config = getNodeConfig();

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <PaneSubHeader />
      <PaneBody
        className="!h-[calc(100%-24px)]"
        tableColumns={columns as IColumn[]}
        data={marginLevels.data || []}
      />
    </>
  );
}
